// extracted by mini-css-extract-plugin
export var text = "_b8-0";